<template>
  <div class="deliveryPicker">
    <z-action-picker v-model="show" title="服务流程" :show-btn="false" @confirm="onConfirm">
      <z-steps direction="vertical">
        <z-step v-for="(item, index) in layerData" :key="index" time="">
          <template slot="title">
            <span>{{ item.text }}</span>
            <span class="step-label" v-if="item.desc">{{ item.desc }}</span>
          </template>
          <template slot="description">
            <div class="setp-description">{{ item.subText }}</div>
            <img
              v-if="item.picture"
              class="img-step"
              :src="$setPicSize(item.picture, 603, 270)"
              @click="userClick(item)"
            />
          </template>
        </z-step>
      </z-steps>
    </z-action-picker>
  </div>
</template>
<script lang="ts">
import Vue from 'vue'
import {
  defineComponent,
  onMounted,
  ref,
  Ref,
  // getCurrentInstance,
  // ComponentInternalInstance,
  computed
} from '@vue/composition-api'

import { Step, Steps, ActionPicker } from '@zz-common/zz-ui'
Vue.use(Step).use(Steps).use(ActionPicker)

export default defineComponent({
  components: {},
  props: {
    deliveryData: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const show: Ref<boolean> = ref(false)
    const layerData = computed(() => {
      const _layerData = props?.deliveryData
      return _layerData?.reverse() || []
    })

    function open() {
      show.value = true
    }

    function onConfirm() {}

    onMounted(() => {
      // do same things...
    })

    return { show, layerData, open, onConfirm }
  }
})
</script>
<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

.deliveryPicker {
  max-height: 70vh;
  /deep/ .z-popup {
    height: 70vh !important;
  }

  /deep/ .z-steps--vertical {
    padding: 16px 0;
    .z-step__icon {
      top: 18px;
    }
    .z-step__title {
      display: flex;
      align-items: center;
      overflow: hidden;
      white-space: nowrap;
    }
    .z-step__description {
      width: calc(100% - 80px);
      padding: 4px 0 78px 40px;
    }
  }
  .step-label {
    @include border-1px(#d8d8d8, 4px);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 32px;
    margin: -2px 0 0 12px;
    padding: 4px 10px;
    color: #111;
    font-weight: 300;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 24px;
    white-space: nowrap;
    text-align: center;
  }
  .setp-description {
    color: #999999;
    font-weight: 300;
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 38px;
  }
  .img-step {
    width: 603px;
    height: 270px;
    margin-top: 26px;
    object-fit: contain;
  }
}
</style>
